import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Capacitor  } from "@capacitor/core"; 

@Component({
  selector: 'app-terms-of-service-page',
  templateUrl: 'terms-of-service.page.html',
  styleUrls: [
    './styles/terms-of-service.page.scss'
  ]
})

export class TermsOfServicePage {


  testUrl = "https://youtube.com/";
  safe: SafeResourceUrl = null;
  test = null;
  
  constructor(
    private modalController: ModalController,
    private sanitizer: DomSanitizer,
    ) { 

       //now safe is safe
    this.safe = this.sanitizer.bypassSecurityTrustResourceUrl(this.testUrl);
    let p = Capacitor.convertFileSrc(this.testUrl);
    this.test = this.sanitizer.bypassSecurityTrustResourceUrl(p);

    }

  ionViewWillEnter(): void {
    
   


    // this.test = this.sanitizer.bypassSecurityTrustUrl(p);
  }



  dismiss(): void {
    this.modalController.dismiss();
  }
}
